exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrolly {\n\theight: 70vh;\n\toverflow-y: scroll;\n}\n.movable {\n\tcursor: move;\n}\n.ghost {\n\tbackground-color: grey;\n}\n.draggable {\n\tmargin-left: 10px;\n}\n.empty:after {\n\tpadding: 10px;\n\tcontent: 'drop here';\n\t/* background-color: rgba(249, 249, 249, 1); */\n\t/* border: 1px dashed rgb(206, 206, 206); */\n\t-webkit-border-radius: 5px;\n\tborder-radius: 5px;\n}\n", ""]);

// exports
